import React from 'react';
import { Frame, Page } from '@shopify/polaris';

import { CartDisplay } from '../components/CartDisplay';

import { CartContextProvider } from '../context-providers/CartContext';

export default function ({ gitCommit, onlyAllowOneEngraving }) {
    console.log({ gitCommit });
    return (
        <Frame>
            <div style={{ padding: '0 2rem' }}>
                <Page title="Add Engraving">
                    <CartContextProvider onlyAllowOneEngraving={onlyAllowOneEngraving}>
                        <CartDisplay />
                    </CartContextProvider>
                </Page>
            </div>
        </Frame>
    );
}
